/* Gospel Archive — Community Archive submission form.
   Validates client-side, submits multipart/form-data (for the optional image),
   and renders exactly the states the backend actually reports. Never fabricates
   a success or "discount sent" state when the backend isn't configured. */
(function () {
  'use strict';

  document.querySelectorAll('[data-archive-form]').forEach(function (root) {
    var form = root.querySelector('[data-archive-form-el]');
    var successEl = root.querySelector('[data-archive-success]');
    var serverErrorEl = root.querySelector('[data-archive-server-error]');
    var submitBtn = root.querySelector('[data-archive-submit]');
    var submitLabel = root.querySelector('[data-archive-submit-label]');
    var endpoint = root.dataset.endpoint;
    var configured = root.dataset.configured === 'true';

    var requiredFields = [
      { id: 'ArchiveName', message: 'Enter your name.' },
      { id: 'ArchiveEmail', message: 'Enter a valid email address.', type: 'email' },
      { id: 'ArchiveDesign', message: 'Tell us your verse or design idea.' },
      { id: 'ArchiveConsent', message: 'Consent is required to submit.', type: 'checkbox' },
    ];

    function setFieldError(id, message) {
      var input = form.querySelector('#' + id);
      var error = form.querySelector('#' + id + '-error');
      if (input) input.closest('.field, .field__checkbox-row').classList.toggle('field--error', !!message);
      if (error) {
        error.textContent = message || '';
        error.hidden = !message;
      }
    }

    function validate() {
      var valid = true;
      requiredFields.forEach(function (field) {
        var input = form.querySelector('#' + field.id);
        if (!input) return;
        var empty = field.type === 'checkbox' ? !input.checked : input.value.trim() === '';
        var invalidEmail = field.type === 'email' && input.value.trim() !== '' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(input.value);
        if (empty || invalidEmail) {
          setFieldError(field.id, field.message);
          valid = false;
        } else {
          setFieldError(field.id, '');
        }
      });
      return valid;
    }

    function setLoading(isLoading) {
      if (!submitBtn) return;
      submitBtn.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
      submitBtn.disabled = isLoading;
      if (submitLabel) submitLabel.textContent = isLoading ? 'Submitting…' : submitLabel.dataset.idleText || submitLabel.textContent;
    }

    if (submitLabel) submitLabel.dataset.idleText = submitLabel.textContent;

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      serverErrorEl.hidden = true;

      // Honeypot: if a bot filled the hidden "company" field, drop the
      // submission silently rather than telling the bot it was rejected.
      var honeypot = form.querySelector('#ArchiveCompany');
      if (honeypot && honeypot.value.trim() !== '') {
        form.hidden = true;
        successEl.hidden = false;
        return;
      }

      if (!validate()) {
        var firstInvalid = form.querySelector('.field--error input, .field--error textarea');
        if (firstInvalid) firstInvalid.focus();
        return;
      }

      if (!configured) {
        serverErrorEl.textContent =
          'Community Archive submissions are not yet connected to a backend. This form is a preview — see docs/community-archive-backend.md to wire it up.';
        serverErrorEl.hidden = false;
        serverErrorEl.setAttribute('role', 'status');
        return;
      }

      setLoading(true);
      var formData = new FormData(form);

      fetch(endpoint, { method: 'POST', body: formData, headers: { Accept: 'application/json' } })
        .then(function (res) {
          return res
            .json()
            .catch(function () { return {}; })
            .then(function (data) { return { ok: res.ok, status: res.status, data: data }; });
        })
        .then(function (result) {
          setLoading(false);
          if (result.ok) {
            form.hidden = true;
            successEl.hidden = false;
            successEl.focus && successEl.focus();
            return;
          }
          if (result.status === 422 && result.data.errors) {
            Object.keys(result.data.errors).forEach(function (key) {
              setFieldError(key, result.data.errors[key]);
            });
            return;
          }
          serverErrorEl.textContent = result.data.message || 'Something went wrong submitting your entry. Please try again in a moment.';
          serverErrorEl.hidden = false;
        })
        .catch(function () {
          setLoading(false);
          serverErrorEl.textContent = 'We could not reach the Community Archive right now. Please try again in a moment.';
          serverErrorEl.hidden = false;
        });
    });
  });
})();
